import { render, staticRenderFns } from "./DecisionsTable.vue?vue&type=template&id=251726d2&scoped=true"
import script from "./DecisionsTable.vue?vue&type=script&lang=js"
export * from "./DecisionsTable.vue?vue&type=script&lang=js"
import style0 from "./DecisionsTable.vue?vue&type=style&index=0&id=251726d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251726d2",
  null
  
)

export default component.exports